import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // 【家族任务】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974655
  {
    path: '/family/goal/user',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-family-goal" */ '~/pages/family/goal')
    ),
  },
  {
    path: '/family/goal/talent',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-family-goal" */ '~/pages/family/goal')
    ),
  },
  {
    path: '/family/goal/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-family-goal-rule" */ '~/pages/family/goal-rule'
        )
    ),
  },
  // 【族长管理中心】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974643
  {
    path: '/family/head/manager',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-family-head-manager" */ '~/pages/family/manager'
        )
    ),
  },
  // 【冷启动rank】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138985728
  {
    path: '/family/rank',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-family-rank" */ '~/pages/family/rank')
    ),
  },
  // 家族恩爱榜
  // 【家族恩爱榜】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138993006
  {
    path: '/family/lovelist',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-family-love-list" */ '~/pages/family/love-list'
        )
    ),
  },
  {
    path: '/family/lovelist/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-family-love-list-rule" */ '~/pages/family/love-list/rule'
        )
    ),
  },
] as RouteConfig[]
